import userReducer from "./features/auth/reducer";
import homeReducer from "./features/home/reducer";
import productReducer from "./features/Admin/products/reducer";
import categoryReducer from "./features/Admin/categories/reducer";

const rootReducer = {
  home: homeReducer,
  products: productReducer,
  categories: categoryReducer,
  user: userReducer,
};

export default rootReducer;
